import { FONT } from "@/styles/common";
import { Center } from "@chakra-ui/react";
import styled from "@emotion/styled";

interface CustomCenterProps {
    isImg: boolean;
}

export const CustomCenter = styled(Center)<CustomCenterProps>`
    width: 100%;
    height: 480px;
    background: ${({ isImg, theme }) => !isImg && theme.COLOR.pagination[100]};
    ${FONT("cormorant", 40, 500)}

    @media (max-width:${({ theme }) => theme.MEDIA.mobile}) {
        height: 240px;
    }
`;
